module.exports = __webpack_public_path__ + "static/img/produce-oversea.e68530a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/produce-oversea.png
// module id = kHIY
// module chunks = 34